import React from 'react';
import { useTranslation } from 'react-i18next';
import { setLocale, SUPPORTED_LOCALES } from '@shared/i18n/index.js';

/**
 * Language toggle, shared by the microsite and the app.
 *
 * Changing the language also rewrites <html lang>, which the Greek uppercase
 * rules in shared/styles/tokens.css depend on — so this is not purely
 * cosmetic.
 *
 * It lived in the microsite until the app turned out to have no way to switch
 * language at all: the app shipped locked to Greek, with the stored choice
 * readable only by editing localStorage. Moved here rather than copied, so the
 * two cannot drift on what the toggle does to <html lang>.
 */
export default function LocaleSwitch({ className = '' }) {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage;

  return (
    <div className={`flex items-center gap-1 ${className}`} role="group" aria-label="Language">
      {SUPPORTED_LOCALES.map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => setLocale(code)}
          aria-current={current === code ? 'true' : undefined}
          className={`label-tag text-[10px] px-2 py-1 rounded transition-colors ${
            current === code ? 'bg-brand text-black' : 'text-white/40 hover:text-white'
          }`}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
